import useMixedItemDist from "@hooks/useMixedItemDist";
import type { RecommendationContext } from "@memorang/types";
import { useMemo } from "react";
import { parseRecommendationContext } from "../recommendations/contract/recommendation-context-schema";

export const parseOptionalRecommendationContext = (
	raw: unknown,
): RecommendationContext | undefined => {
	if (!raw) {
		return undefined;
	}
	try {
		return parseRecommendationContext(raw);
	} catch {
		return undefined;
	}
};

/**
 * The common distribution's recommendation context, validated once per data
 * reference. Undefined whenever the payload is absent or fails the contract —
 * surfaces then fall back per the display hierarchy (never "More data needed").
 */
export const useParsedRecommendationContext = ():
	| RecommendationContext
	| undefined => {
	const { data } = useMixedItemDist();
	const raw = data?.recommendationContext;
	return useMemo(() => parseOptionalRecommendationContext(raw), [raw]);
};
